import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store/index.js';
import App from 'App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from 'theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CssBaseline>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </CssBaseline>,
);
